import { useRouteError, isRouteErrorResponse, useNavigate } from 'react-router-dom'
import { Button } from './ui/button'
import { Card } from './ui/card'
import { Home, ArrowLeft, AlertCircle } from 'lucide-react'

export function RouteErrorBoundary() {
  const error = useRouteError()
  const navigate = useNavigate()

  let errorMessage: string
  let errorStatus: number | undefined

  if (isRouteErrorResponse(error)) {
    errorMessage = error.statusText || error.data?.message
    errorStatus = error.status
  } else if (error instanceof Error) {
    errorMessage = error.message
  } else {
    errorMessage = 'Ha ocurrido un error inesperado'
  }

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleGoHome = () => {
    navigate('/')
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-muted dark:bg-background">
      <Card className="max-w-lg w-full p-8 text-center bg-background dark:bg-card border-border dark:border-border">
        {/* Icon */}
        <div className="mb-6 flex justify-center">
          <div className="w-20 h-20 rounded-full bg-red-100 dark:bg-red-900/20 flex items-center justify-center">
            <AlertCircle className="h-10 w-10 text-red-600 dark:text-red-400" />
          </div>
        </div>

        {errorStatus && (
          <div className="text-6xl font-bold text-muted-foreground dark:text-foreground mb-4">
            {errorStatus}
          </div>
        )}

        <h1 className="text-2xl font-bold text-foreground dark:text-white mb-2">
          {errorStatus === 404 ? 'Página no encontrada' : '¡Ups!'}
        </h1>

        <p className="text-muted-foreground dark:text-muted-foreground mb-6">
          {errorStatus === 404
            ? 'La página que buscas no existe.'
            : errorMessage}
        </p>

        {process.env.NODE_ENV === 'development' && error instanceof Error && (
          <div className="mt-6 p-4 bg-muted dark:bg-background rounded-lg text-left border border-border dark:border-border">
            <h2 className="text-sm font-semibold text-foreground dark:text-muted-foreground mb-2">
              Detalles del Error (Modo Desarrollo)
            </h2>
            <pre className="text-xs text-muted-foreground dark:text-muted-foreground font-mono overflow-auto whitespace-pre-wrap">
              {error.stack}
            </pre>
          </div>
        )}

        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-6">
          <Button
            onClick={handleGoBack}
            variant="outline"
            className="flex items-center gap-2 text-foreground dark:text-foreground border-border dark:border-border hover:bg-muted dark:hover:bg-accent"
          >
            <ArrowLeft className="w-4 h-4" />
            Volver
          </Button>
          <Button
            onClick={handleGoHome}
            className="flex items-center gap-2 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white"
          >
            <Home className="w-4 h-4" />
            Ir al Inicio
          </Button>
        </div>
      </Card>
    </div>
  )
}
